module.exports = __webpack_public_path__ + "static/media/scca-runoffs-2025@2X.87d4d2f6.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/scca-runoffs-2025@2X.png
// module id = 1162
// module chunks = 0